module.exports = __webpack_public_path__ + "img/magafilio_logo_modo_claro.39f2a366.png";